"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _defaultTheme = require("./defaultTheme");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var TabItems = function TabItems(_ref) {
  var tabItems = _ref.tabItems,
    handleTabChange = _ref.handleTabChange,
    currentTab = _ref.currentTab,
    orientation = _ref.orientation,
    _ref$customTheme = _ref.customTheme,
    customTheme = _ref$customTheme === void 0 ? {} : _ref$customTheme;
  var getTabLalbel = function getTabLalbel(_ref2) {
    var name = _ref2.name,
      count = _ref2.count,
      clsName = _ref2.clsName,
      index = _ref2.index;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, name, count && /*#__PURE__*/_react.default.createElement("span", {
      className: "index_".concat(index, " ").concat(clsName, "_count")
    }, count)));
  };
  var TABs = tabItems.map(function (tab, index) {
    return /*#__PURE__*/_react.default.createElement(_core.Tab, {
      index: index,
      label: getTabLalbel(_objectSpread(_objectSpread({}, tab), {}, {
        index: index
      })),
      key: index,
      className: tab.clsName,
      disableRipple: true
    });
  });
  var themeConfig = (0, _core.createTheme)({
    overrides: _objectSpread(_objectSpread({}, (0, _defaultTheme.defaultTheme)()), customTheme)
  });
  return /*#__PURE__*/_react.default.createElement(_core.ThemeProvider, {
    theme: themeConfig
  }, /*#__PURE__*/_react.default.createElement(_core.Tabs, {
    onChange: function onChange(event, value) {
      return handleTabChange(event, value);
    },
    value: currentTab,
    TabIndicatorProps: {
      style: {
        background: 'none'
      }
    },
    orientation: orientation
  }, TABs));
};
var _default = TabItems;
exports.default = _default;